export interface ContextRoleScopeComponentItemDTO {
    fieldValue?: string;
    fieldDisplayValue?: string;
}
